export const getLocalizedFilter =
  (filter: string, languageAndCountry: string, countryCode?: string): string => {

    return filter
      .replaceAll(':LANGUAGE_AND_COUNTRY', languageAndCountry)
      .replaceAll(':COUNTRY_CODE', countryCode || '');
  
  };
